<template>
<div class="container">

  <p class="pageHeading m4u_text--text">Invite a charter member to join Memories For Us</p>

   <v-form  ref="form">
    <v-container>

    {{confirmation}}
      <v-card>
        <v-card-text>
      <h3 class="m4u_text--text">Message text?</h3>
      <v-row>
        <v-col
          cols="12"
          md="6"
        >
        <v-textarea 
        v-model="messageText"
        label="message text"
        required>
        </v-textarea>
        </v-col>

        <v-col
          cols="12"

        >
          <v-text-field
            v-model="messageStart"
            label="Start Date"
            required
          ></v-text-field>
        </v-col>
        <v-col
          cols="12"

        >
          <v-text-field
            v-model="messageEnd"
            label="End Date"
            required
          ></v-text-field>
        </v-col>
      </v-row>

      </v-card-text>
      <v-btn class="primary mb-2 ml-3 m4u_text--text button" @click="addMessage()">Add Message</v-btn>
      </v-card>
    </v-container>
  </v-form>
</div>

</template>
<script>

import EventService from '@/services/EventService.js'; 

export default {
 name: "adminmessage",
  data() {
    return {
      
      messageText: '',
      messageStart: '',
      messageEnd: '',
      confirmation: ''
      
       }
    },
  
  components: {

  },
  
mounted() {


  },


computed: {
  user(){
    return this.$store.state.user
  },

    loginState(){
    return this.$store.state.loginState
  },

},

  methods: {
      async addMessage() {
      await EventService.addMessage(this.user.UserID, this.messageText, this.messageStart, this.messageEnd)
      .then(
        (invitationreturn => {
            this.confirmation = 'Your message is saved';
        })
      )
    }
  }

}


</script>
<style lang="scss" scoped>
  .button {
    font-weight: 600;
  }

  .formCard {
    max-width: 90%;
    justify-content: center;
  }

  .pageHeading {
    font-size: 1.25em;
    font-weight: 600;
  }

  .pageSubHeading {
    font-size: 1em;
  }

  .toggleButtons {
    margin-bottom: 1em;
    margin-top: 1.25em;

  }

  .outerDiv {
    background-color: white;
  }

 .warningtext {
   font-size: 1.25em;
 }


</style>